import YubinBango from 'yubinbango-core2/yubinbango-core';

export const getAddress = (zip) => {
  return new Promise((resolve) => {
    /* eslint-disable no-new */
    new YubinBango.Core(zip, (address) => resolve(address));
  });
};
